import SearchEngineAdapter from 'Services/Adapters/SearchEngineBeta/SearchEngineAdapter';
import { v4 as uuidv4 } from 'uuid';

export default class ProductAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'item';
    }

    constructor(data = [], query = '') {
        super(data, query);
        this.key = ProductAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Produit / Service'),
            count: 0,
            items: [],
            filters: ['item.product', 'item.service', 'declination'],
        };
    }

    extractDataByType() {
        let data = [];

        if (!Array.isArray(this.data)) {
            this.data = [this.data];
        }

        if (this.data) {
            data = this.data.filter((item) => {
                return ['item', 'declination'].includes(item.object.type) && !item.is_archived;
            });
        }

        return data;
    }

    formatItem(item) {
        return {
            id: item.object.id,
            name: this.checkFieldForQuery(item.name),
            number: this.checkFieldForQuery(item.number),
            type: item.object.type,
            subtype: this.getLabelByType(item.object.sub_type),
            link: this.getLink(item),
            description: this.checkFieldForQuery(this.stripTags(item.description)),
            component: 'search-result-product',
            uuid: uuidv4(),
        };
    }

    getLink(item) {
        switch (item.object.type) {
            case 'declination':
                return `/?_f=catalogueitem&id=${item.related.id}&declid=${item.object.id}`;
            case 'item':
            default:
                return `/?_f=catalogueitem&id=${item.object.id}`;
        }
    }

    getLabelByType(subtype) {
        switch (subtype) {
            case 'service':
                return window.i18n.__('Service');
            case 'item':
            default:
                return window.i18n.__('Produit');
        }
    }
}
